/* eslint-disable */
/**
 * COPIED VERBATIM from src/app/components/direct/components/directCellStyles.js (commit 7772aebb).
 * Do not edit: kept byte-identical so a two-way diff against the source stays meaningful
 * while both modules coexist. Ashvini's module is scheduled for removal; when it goes,
 * this copy becomes the only one and the eslint-disable above should be dropped.
 */
/**
 * Prozo Direct — numeric cell styles.
 *
 * Why this exists rather than reusing orders/list2/cellStyles.js awbTextSx: that
 * style is *documented* as monospace but is actually Poppins (fontFamily: FONT).
 * TRD 4.3 requires every numeric, currency, AWB, pincode and account-code cell to be
 * monospace with tabular numerals and right-aligned, so that a column of rupees
 * lines up on the decimal. Poppins does not do that.
 *
 * Text cells still use the shared primaryTextSx / secondaryTextSx / tertiaryTextSx
 * from orders/list2/cellStyles.js — this file only adds what is genuinely missing.
 */
import {SIZE, WEIGHT} from '../../../styles/foundation/typography'
import {NAVY, SUBTLE, ERROR} from '../../../styles/foundation/colors'

export const MONO = "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace"

// Account codes, AWBs, pincodes — identifiers, left-aligned (they are not quantities).
export const monoIdSx = {
  fontFamily: MONO,
  fontWeight: WEIGHT.semibold,
  fontSize: SIZE['3xs'],
  fontVariantNumeric: 'tabular-nums',
  color: NAVY,
  lineHeight: 1.4,
  letterSpacing: '-0.01em',
}

// Quantities and currency — right-aligned so decimals align down the column.
export const monoNumSx = {
  fontFamily: MONO,
  fontWeight: WEIGHT.semibold,
  fontSize: SIZE['3xs'],
  fontVariantNumeric: 'tabular-nums',
  color: NAVY,
  lineHeight: 1.4,
  textAlign: 'right',
  width: '100%',
  display: 'block',
}

export const monoNumMutedSx = {...monoNumSx, fontWeight: WEIGHT.regular, color: SUBTLE}

export const monoNumAlertSx = {...monoNumSx, color: ERROR}

// Right-align the header too, or the header text sits over the wrong edge of a
// right-aligned column.
export const numericColumnProps = {
  align: 'right',
  headerAlign: 'right',
}
